const getApi = {
  nopage: '/notar/page',
  faceQrcode: '/user/faceQrcode',
  code: '/valicode/code',
  jqzReturn: '/cb/jqzReturn',
  jzqNotify: '/cb/jzqNotify',
  detail: '/exec/detail',
  expage: '/exec/page',
  logout: '/user/logout',
  execDetail: '/exec/detail',
  profile: '/user/profile',
  chainList: '/chain/list',
  userDetail: '/user/detail', // 当前用户基础信息
  busiList: '/tpl/busiList', // 业务列表
  /* ==================== 执行公证（赋强执行）模块，后端已出：Notar Enforce Apply Controller /enforce/* ==================== */
  execNotarPage: '/enforce/page', // 执行公证案件列表 GET /enforce/page
  execNotarDetail: '/enforce/detail', // 执行公证详情 GET /enforce/detail
  execNotarApplyerList: '/enforce/applyerList', // 执行公证申请人材料 GET /enforce/applyerList
  execNotarRVisit: '/enforce/rVisit', // 执行公证回访记录 GET /enforce/rVisit
  execNotarInfo: '/enforce/essentialInformation', // 执行公证基本资料 GET /enforce/essentialInformation
  execNotarView: '/enforce/notarView', // 执行公证书PDF文件 GET /enforce/notarView
  execNotarQueryStatus: '/enforce/queryNotarlStatus', // 执行公证所有案件状态 GET /enforce/queryNotarlStatus
  execNotarApplyTempDelete: '/enforce/applyTempDelete', // 执行公证草稿删除 GET /enforce/applyTempDelete
  execNotarCancelApply: '/enforce/cancelApply', // 执行公证取消申请 GET /enforce/cancelApply
  /* ==================== 执行公证（赋强执行）模块 getApi end ==================== */
  notarDetail: '/notar/detail', // 公证书详情
  busiFromList: '/tpl/busiFromList', // 业务表单查询
  busiTplList: '/notar/busiTplList', // 查询业务材料列表
  getSignUrl: '/notar/signUrl',
  generalBusiNo: '/general/genBusiNo',
  generalPage: '/general/page',
  valicode: '/valicode/code', // 获取验证码
  validPre: '/chain/validPre', // 验证保全
  oneWeekCal: '/booking/oneWeekCal', // 查询预约日期
  appointPage: '/booking/page', // 预约列表查询
  frequentList: '/contacts/list', // 常用联系人列表
  applyerList: '/general/applyerList', // 一般公证申请人材料
  rVisit: '/general/rVisit', // 一般公证回访记录
  notarApplyerList: '/notar/applyerList', // 赋强公证申请人材料
  notarRVisit: '/notar/rVisit', // 赋强公证回访记录
  preview: '/file/preview', // 文件预览
  getQRCode: '/file/getUpFileQRCode', // 获取上传文件二维码
  previewPdf: '/file/previewPdf', // PDF文件预览
  findPayLink: '/pay/findPayLink', // 获取支付链接
  queryCertificateNumberList: '/general/queryCertificateNumberList', // 获取公证书字第号列表
  findBusinessGuide: '/tpl/findBusinessGuide', // 查询业务指南
  /* ======================== 自助/赋强公证模块 ================== */
  querySignLink: '/commonNotar/querySignLink', // 获取签约链接
  queryRefund: '/commonNotar/queryRefund', // 查询退款信息
  queryMaterialModificationLog: '/commonNotar/queryMaterialModificationLog', // 查询材料修改日志
  materialModificationDetectionStatus: '/commonNotar/materialModificationDetectionStatus', // 材料修改检测状态(检测最新记录是否为当前用户，如果是返回null，否则返回修改数据)
  queryAllTplFillContent: '/commonNotar/queryAllTplFillContent', // 查询所有模板填写内容
  queryGeneralStatus: '/general/queryGeneralStatus',//获取自助所有案件状态
  queryNotarlStatus: '/notar/queryNotarlStatus',//获取赋强所有案件状态
  generalApplyTempDelete: '/general/applyTempDelete',//自助公证草稿删除
  notarApplyTempDelete: '/notar/applyTempDelete',//赋强公证草稿删除

  generalCancelApply: '/general/cancelApply',//自助取消申请
  notarCancelApply: '/notar/cancelApply',//赋强取消申请


  /** 公证证书 */
  notarialCertificateQueryPage: '/notarial-certificate/query-page', // 分页条件查询
  notarialCertificateQueryDetail: '/notarial-certificate/query-detail', // 查询详情
  notarialCertificateQueryExtract: '/notarial-certificate/query-extract', // 查询提取信息
  queryCertificateStatus: '/notarial-certificate/queryStatus',//获取公证证书所有案件状态

  /** 保管函 */
  safeKeepLetterQueryPage: '/safe-keep-letter/query-page', // 分页条件查询
  safeKeepLetterQueryDetail: '/safe-keep-letter/query-detail', // 查询详情
  safeKeepLetterQueryExtract: '/safe-keep-letter/query-extract', // 查询提取信息

  /** 用户收件地址 */
  queryUserConsignee: '/user-consignee/query-info', // 查询用户收件信息
  queryPaymentVoucher: '/commonNotar/queryPaymentVoucher', // 查询缴费凭证

  authGenerate: '/auth/generate',

  bindingSbgzAuthHandler: '/binding/sbgzAuthHandler',
  queryBusi: '/tpl/queryBusi',//查询业务分配
  hotMatter: '/tpl/hotMatter',//首页常用业务信息
  generalInfo: '/general/essentialInformation',//自助获取基本资料
  notarInfo: '/notar/essentialInformation',//赋强获取基本资料

  /*** 视频回访 ***/
  videoCallQuery: '/videocall/query', //查询视频通话订单
  queryInviteeInfo: '/videocall/queryInviteeInfo', // 查询受访人信息
  contractDetail: '/contract/detail',//获取验证码
  notarView: '/notar/notarView',//公证书PDF文 件
  systemConfigQuery: '/systemConfig/query',//查询系统配置
  reservation: '/reservation/reservation',//公证预约
  faceGetMiddlePage: '/face/getMiddlePage',//获取视频通话中间页
  queryDepositOrder: '/depositOrder/query',//查询提存公证订单
  totalAmountDepositOrder: '/depositOrder/totalAmount',//查询订单总额
  queryDepositPayment: '/depositPayment/query',//查询提存公证订单
  queryConsumeLedger: '/consumeLedger/query',//查询提存公证订单
  queryAccountDepositPayment: '/depositPayment/queryAccount',//查询转账账号
  queryAccountConsumeLedger: '/consumeLedger/queryAccount',//查询转账账号

  evidenceQueryPage: '/evidence/queryPage',//分页条件查询
  eleteEvidence: '/evidence/deleteEvidence',//删除存证
  evidenceDetail: '/evidence/evidenceDetail',//存证详情
  evidenceEdit: '/evidence/evidenceEdit',//存证修改
  queryReceiptsNotify: '/depositPayment/queryReceiptsNotify',//查询入金通知订单
  queryBalanceAll: '/depositPayment/queryBalanceAll',//查询所有子户余额
  depositPaymentQueryPage: '/depositPayment/queryPage',//根据创建人查询提存公证所有订单
  consumeLedgerQueryPage: '/consumeLedger/queryPage',//根据创建人查询提存公证所有订单
  queryPageApplicant: '/depositPayment/queryPageApplicant',//申请人查询提存公证所有订单
  queryPageApplicantConsumeLedger: '/consumeLedger/queryPageApplicant',//申请人查询提存公证所有订单
  queryBusiTplPreview: '/tpl/queryBusiTplPreview',//申请人查询提存公证所有订单
  queryParamBusiTplPreview: '/tpl/queryParamBusiTplPreview',//申请人查询提存公证所有订单
}
const postApi = {
  login: '/anony/login',
  regist: '/anony/regist',
  updatePwd: '/user/updatePwd',
  vcode: '/valicode/vcode',
  propProof: '/exec/propProof',
  chainDetail: '/chain/query',
  notarApply: '/notar/notarApply', // 申请公证书,可幂等提交
  /* ==================== 执行公证模块（后端接口待定，预留路径，待后端对齐） ==================== */
  execNotarApply: '/enforce/notarApply', // 执行公证申请（发起赋强公证申请） POST /enforce/notarApply，可幂等提交
  execNotarApplyTemp: '/enforce/notarApplyTemp', // 执行公证申请草稿（发起赋强公证申请草稿） POST /enforce/notarApplyTemp
  execNotarAffirmNotarApply: '/enforce/affirmNotarApply', // 执行公证确认提交（申请材料-确认提交,确认后将不能再上传合同,可等待提交） POST /enforce/affirmNotarApply
  execNotarGenBusiNo: '/enforce/genBusiNo', // 执行公证业务编码 POST /enforce/genBusiNo
  execNotarSignNotify: '/enforce/signNotify', // 执行公证签署提醒（合同提醒签署） POST /enforce/signNotify
  execNotarPreview: '/enforce/preview', // 执行公证预览（提交前预览） POST /enforce/preview
  execNotarCancel: '/enforce/cancel', // 执行公证撤销 POST /enforce/cancel（公证取消）
  /* ==================== 执行公证模块 end ==================== */
  affirmNotarApply: '/notar/affirmNotarApply', // 申请材料-确认提交(确认后将不能再上传合同),可幂等提交
  genBusiNo: '/notar/genBusiNo', // 业务编码
  signNotify: '/notar/signNotify',
  queryBusiTpls: '/tpl/queryBusiTpls',
  generalApply: '/general/apply',
  generalApplyTemp: '/general/applyTemp',//自助公证草稿
  notarApplyTemp: '/notar/notarApplyTemp',//发起赋强公证申请草稿

  generalPreview: '/general/preview',
  generalAffirmApply: '/general/affirmApply',
  generalSignNotify: '/general/signNotify',
  generalDetail: '/general/detail',
  preview: '/notar/preview',
  order: '/booking/order', // 预约

  pdfToImg: '/tpl/pdfToImg',


  sendRandomCode: '/valicode/sendCode', // 发送随机验证码,
  restPassword: '/anony/findPwd', // 找回密码
  verifyCert: '/verifyCert', // 验证公证书
  verifyUserName: '/anony/verifyUserName', // 验证用户名是否存在

  delFrequent: '/contacts/deleteById', // 删除常用联系人

  /** 用户收件地址 */
  saveOrUpdate: '/user-consignee/save-or-update', // 新增或修改收件地址

  /** 公证证书 */
  notarialCertificateDownOriginalFile: '/notarial-certificate/down-original-file', // 下载原文件(扫码下载)
  deleteCertificate: '/notarial-certificate/delete',//删除公证记录

  /** 保管函 */
  safeKeepLetterDownOriginalFile: '/safe-keep-letter/down-original-file', // 下载原文件(扫码下载)
  deleteKeepLetter: '/safe-keep-letter/delete',//删除保管函记录
  applyNotarial: '/safe-keep-letter/applyNotarial',//申请出公证书
  queryMaterials: '/user/queryMaterials',

  querySupplementMaterial: '/commonNotar/querySupplementMaterial', // 查询补充材料(申请端)
  queryApplyMaterials: '/commonNotar/queryApplyMaterials',//查询材料
  generalNotarView: '/general/notarView',//获取自助页面展示的公证书

  updateCredentials: '/user/updateCredentials',//用户上传证明文件
  hddkPreview: '/custom/notar/common/preview', // 定制录入-洪洞线上证词贷款
  hddkAffirmNotarApply: '/custom/notar/common/affirmNotarApply', // 定制录入-洪洞线上证词贷款
  sendValiCode: '/anony/sendValiCode', // 发送手机/邮箱验证码
  loginValiCode: '/anony/loginValiCode', // 发送手机/邮箱验证码

  notarCancel: '/notar/cancel',//公证取消
  loginH5: '/user/loginH5 ',//获取登录H5地址
  depositPaymentRecordQuery:'/depositPayment/recordQuery',//账簿收支明细查询
  previewConsumeLedger: '/consumeLedger/preview', // 预览确认单
  // confirmConsumeLedger: '/consumeLedger/confirm', // 预览确认单
  consumeLedgerRevoke: '/consumeLedger/revoke', // 撤销消费分账订单
}
const postJsonApi = {
  propProof: '/exec/propProof', // 申请人举证
  respProof: '/exec/respProof', // 被申请人举证
  editDetail: '/user/editDetail', // 编辑当前用户基础信息
  frequentSave: '/contacts/save', // 保存/修改联系人
  identityVerify: '/identity/verify', // 身份认证/读取信息

  checkFile: '/file/checkFile', // 检查扫码上传是否成功

  /* ======================== 自助/赋强公证模块 ================== */
  applyRefund: '/commonNotar/applyRefund', // 申请退款

  modificationTplFillContent: '/commonNotar/modificationTplFillContent', // 修改模板填写内容

  saveDrafts: '/notarial-certificate/saveDrafts',//公证书保存草稿
  submit: '/notarial-certificate/submit',//公证书提交公证
  keepLetterSaveDrafts: '/safe-keep-letter/saveDrafts',//保管函保存草稿
  keepLetterSubmit: '/safe-keep-letter/submit',//保管函提交公证
  hddkApply: '/custom/hddk/apply', // 定制录入-洪洞线上证词贷款
  hddkDoubleApply: '/custom/hddkDouble/apply', // 定制录入-洪洞线上证词贷款
  createDepositOrder: '/depositOrder/create', // 创建提存公证订单
  addAttachmentDepositOrder: '/depositOrder/addAttachment', // 补充凭证
  createDepositPayment: '/depositPayment/create', // 创建提存公证订单
  createConsumeLedger: '/consumeLedger/create', // 创建提存公证订单
  previewDepositPayment: '/depositPayment/preview', // 预览确认单

  replenishAttach: '/depositPayment/replenishAttach', // 补充凭证

}
const postMutilApi = {
  upFile: '/file/upFile', // 上传临时文件
  tplcustomFile: '/tpl/customFile',//

  identityOcr: '/ocr/identityOcr', // OCR识别

  uploadFeesProof: '/commonNotar/uploadFeesProof', // 自助/赋强公证上传缴费凭证

  /** 公证证书 */
  notarialCertificateUploadEvidence: '/notarial-certificate/upload-evidence', // 上传证据
  notarialCertificateReplenishAuthMaterial: '/notarial-certificate/replenish-auth-material', // 补充身份材料
  notarialCertificateQueryFileHash: '/notarial-certificate/query-file-hash', // 查看文件Hash

  /** 保管函 */
  safeKeepLetterUploadEvidence: '/safe-keep-letter/upload-evidence', // 上传证据
  safeKeepLetterReplenishAuthMaterial: '/safe-keep-letter/replenish-auth-material', // 补充身份材料
  safeKeepLetterQueryFileHash: '/safe-keep-letter/query-file-hash', // 查看文件Hash
  replenishProposerAccessory: '/commonNotar/replenishProposerAccessory',// 补充申请人材料
  editMaterials: '/user/editMaterials',//上传当前用户证件图片
  fileUploadHash: '/file/uploadHash',//生成文件hash
  consumeLedgerConfirm: '/consumeLedger/confirm',//确认消费分账订单


}

const downloadApi = {
  download: '/notar/download',
  /* ==================== 执行公证（赋强执行）模块，后端已出：Notar Enforce Apply Controller /enforce/* ==================== */
  execNotarDown: '/enforce/download', // 执行公证下载执行申请材料 POST /enforce/download
  execNotarDownCert: '/enforce/downCert', // 执行公证书下载 POST /enforce/downCert（下载公证书）
  /* ==================== 执行公证（赋强执行）模块 downloadApi end ==================== */
  down: '/exec/down',
  generalDown: '/general/down',
  fileDown: '/file/down', // 通用文件下载
  notarDownCert: '/notar/downCert', //下载赋强公证公证书
  downVoucher: '/depositPayment/downVoucher', //下载电子回单
  downVoucherConsumeLedger: '/consumeLedger/downVoucher', //下载电子回单

  /** 公证证书 */
  notarialCertificateDownAll: '/notarial-certificate/down-all', // 下载所有材料

  /** 保管函 */
  safeKeepLetterDownAll: '/safe-keep-letter/down-all', // 下载所有材料

  downAll: '/notarial-certificate/batchDownAll',//批量下载公证书材料
  keepLetterBatchDownAll: '/safe-keep-letter/batchDownAll',//批量下载保管函材料

  generalDownCert: '/general/downCert', //下载一般公证全部公证书
}
module.exports = {
  get: getApi,
  post: postApi,
  postJson: postJsonApi,
  postMutil: postMutilApi,
  download: downloadApi
}



// WEBPACK FOOTER //
// ./src/http/api.js